import React, { useState } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import { Link } from "react-router-dom";

export default function ReportAllPositionInSitePublisher() {
  const [positions, setPositions] = useState([]);
  const sendForm = async (e) => {
    e.preventDefault();
    const sitePublisherID = parseInt(
      document.querySelector("#site-publisher-id").value
    );

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const reportPositions = await sendRequestGetReport(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!reportPositions) {
      return;
    }
    setPositions(reportPositions);
  };

  const sendRequestGetReport = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/report-all-positions-in-site-publisher/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateCampaignInPositionTag = (campaignsState) => {
    return campaignsState.map((campaign) => {
      return (
        <>
          <div className="p-2 bg-warning border border-1">
            <div className="border-bottom">
              <span>شماره کمپین :‌ </span>
              <span>{campaign.id}</span>
            </div>
            <div className="border-bottom">
              <div>تاریخ شروع : </div>
              <div className="number-finance" dir="ltr">
                {" "}
                {helperNumbers.toPersianNum(
                  helpersTime.convertGregorianToJalali(campaign.start_date) +
                    " 00:00"
                )}
              </div>
            </div>
            <div>
              <div>تاریخ پایان : </div>
              <div className="number-finance" dir="ltr">
                {helperNumbers.toPersianNum(
                  helpersTime.convertGregorianToJalali(campaign.end_date) +
                    " 23:59"
                )}
              </div>
            </div>
          </div>
          <hr />
        </>
      );
    });
  };

  const generatePositions = () => {
    return (
      <div className="container-fluid p-0">
        <div className="row">
          {positions.map((position, index) => {
            return (
              <div className="col-12 col-lg-4">
                <div className="card">
                  <div className="card-body p-0 bg-primary ">
                    <div className="text-center p-2 border-bottom text-dark">
                      {index + 1}
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      {position.tag_html_id}
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <span>تعداد بنر : </span>
                      <span>{position.count}</span>
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <span> اندازه : </span>
                      <span dir="ltr">{position.size.replace("-", " * ")}</span>
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <div className="pb-2"> آدرس صفحه : </div>
                      <div dir="ltr">{position.website_url}</div>
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <span>الگو صفحه : </span>
                      <span dir="ltr">
                        {position.pattern_url == "0"
                          ? "مستقل"
                          : position.pattern_url}
                      </span>
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <div>کمپین های فعال</div>
                      <div>
                        {position.campaign_IDS_active.length !== 0 ? (
                          generateCampaignInPositionTag(
                            position.campaign_IDS_active
                          )
                        ) : (
                          <>این جایگاه هیچ کمپین فعال ندارد</>
                        )}
                      </div>
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <div>کمپین های در حال انتظار</div>
                      <div>
                        {position.campaign_IDS_pending.length !== 0 ? (
                          generateCampaignInPositionTag(
                            position.campaign_IDS_pending
                          )
                        ) : (
                          <>این جایگاه هیچ کمپین در حالت انتظار ندارد</>
                        )}
                      </div>
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <div>کمپین های جایگزین فعال</div>
                      <div>
                        {position.campaign_IDS_active_alternative.length !==
                        0 ? (
                          generateCampaignInPositionTag(
                            position.campaign_IDS_active_alternative
                          )
                        ) : (
                          <>این جایگاه هیچ کمپین جایگزین فعال انتظار ندارد</>
                        )}
                      </div>
                    </div>
                    <div className="text-center p-2 border-bottom text-dark">
                      <div>کمپین های جایگزین در حال انتظار</div>
                      <div>
                        {position.campaign_IDS_pending_alternative.length !==
                        0 ? (
                          generateCampaignInPositionTag(
                            position.campaign_IDS_pending_alternative
                          )
                        ) : (
                          <>این جایگاه هیچ کمپین جایگزین در حالت انتظار ندارد</>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  گزارش جایگاه ها در سایت نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <p className="alert alert-info">
                  شماره سایت نمایش دهنده را می توانید از این
                  <Link
                    className="d-inline-block px-2"
                    to="/manage/publishers/all"
                    target="_blank"
                  >
                    لیست
                  </Link>
                  پیدا کنید.
                </p>
                <form onSubmit={sendForm} className="d-flex align-items-end">
                  <div className="form-group flex-grow-1">
                    <label>شماره سایت نمایش دهنده را وارد کنید</label>
                    <input
                      type="number"
                      className="form-control"
                      id="site-publisher-id"
                      placeholder="شماره سایت نمایش دهنده"
                      required
                    />
                  </div>
                  <div className="form-group pr-2">
                    <button className="btn btn-primary">نمایش اطلاعات</button>
                  </div>
                </form>
              </div>
              <div>{positions.length !== 0 ? generatePositions() : <></>}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
